export default "__VITE_ASSET__rIKvki$h__"